<template>
  <div class="select-wrap" :class="{'active': selectitem}">
    <span class="select" @click="showSelectOption">{{ title }}<van-icon name="arrow" /></span>
    <div class="select-content" @click="selectContentClick">
      <slot name="content"></slot>
      <slot name="btn">
        <footer class="flex">
          <van-button class="flex-item" type="primary" @click="confirm">{{confirmText}}</van-button>
        </footer>
      </slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SelectLayer',
  props: {
    title: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: '保存选择'
    }
  },
  data() {
    return {
      checked: false,
      selectitem: false,
      showModal: false
    }
  },
  mounted() {
    this.clickInit();
  },
  destroyed() {
    // document.body.removeEventListener("click", this.docFn)
  },
  methods: {
    showSelectOption(e) {
      e.stopPropagation();
      this.selectitem = !this.selectitem
    },
    selectContentClick(e) {
      e.stopPropagation();
    },
    confirm() {
      this.$emit('confirm')
      this.selectitem = false;
    },
    clickInit() {
      // document.body.addEventListener('click', this.docFn);
    },
    docFn() {
      this.$emit('cancel')
      this.selectitem = false;
    }
  }
}
</script>
<style lang="less" scoped>
@import '~style/var.less';
@import '~style/mixin.less';
.select-wrap {
  position: relative;
  display: inline-block;
}

.select-wrap.active {
  .select-content {
    max-height: 1000px;
    transition: all 0.3s;
    background-color: #fff;
  }
  .van-icon-arrow {
    transform: rotate(90deg);
    transition: all 0.3s;
  }
}

.van-icon-arrow {
  transform: rotate(0deg);
  transition: all 0.3s;
}

.select {
  display: inline-block;
  position: relative;
  padding: 6px 10px;
}

.select-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 7.5rem;
  max-height: 0px;
  overflow: hidden;
  transition: all 0.3s;
  background-color: #fff;
  box-shadow: 0px 0px 13px 0px #a3a3a3;
  z-index: 2003;
}

.van-icon {
  vertical-align: middle;
  font-size: 14px;
  margin-left: 8px;
}

.van-button {
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectLayer.vue